/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _get from 'lodash/get'
import _isObject from 'lodash/isObject'
import _mergeWith from 'lodash/mergeWith'
import { NOT_SECURE_API_TYPES } from 'constants/apiTypes'
import { USER_LOGOUT_ACTION } from 'constants/user'

const customizer = (objValue, srcValue) => {
  // Disable merging arrays deeply because we may want to delete some array elements from its tail
  if (Array.isArray(objValue)) {
    return srcValue
  }

  if (_isObject(objValue)) {
    if (Object.keys(srcValue).length) {
      return _mergeWith({ ...objValue }, srcValue, customizer)
    }
    return _mergeWith({}, srcValue, customizer)
  }

  return undefined
}

/**
 * Reducer, updates an entity cache in response to any action with payload.entities
 */
export default (state = {}, action) => {
  if (action.type === USER_LOGOUT_ACTION) {
    return NOT_SECURE_API_TYPES.reduce((acc, apiEntity) => ({
      ...acc,
      [apiEntity]: _get(state, apiEntity),
    }), {})
  }
  if (action.payload && action.payload.entities) {
    return _mergeWith({ ...state }, action.payload.entities, customizer)
  }

  return state
}
